export const REFRESH_INTERVALS = {
  GAMEPLAY: 1000,
  LOBBY: 5000,
  USER_PROFILE: 2000,
  STATS: 10000,
  TRANSACTIONS: 30000,
  PRICE_DATA: 30000,
} as const;

export const STALE_TIMES = {
  GAMEPLAY: 500,
  LOBBY: 3000,
  USER_PROFILE: 1000,
  STATS: 5000,
  TRANSACTIONS: 15000,
} as const;

export const CACHE_TIMES = {
  DEFAULT: 60000,
  LONG: 300000,
  SHORT: 10000,
} as const;

export const RATE_LIMITS = {
  API_GENERAL: { windowMs: 60000, max: 100 },
  API_AUTH: { windowMs: 60000, max: 20 },
  API_GAME_ACTION: { windowMs: 1000, max: 10 },
} as const;

export const POKER_CONFIG = {
  MIN_PLAYERS_TO_START: 2,
  MAX_PLAYERS_PER_TABLE: 6,
  TOURNAMENT_MAX_PLAYERS: 9,
  ACTION_TIMEOUT_MS: 30000,
  HAND_TIMEOUT_MS: 120000,
} as const;

/** @deprecated prefer GBUX from @shared/fleet — kept for server SPL service */
export const GBUX_TOKEN = {
  ADDRESS: '55TpSoMNxbfsNJ9U1dQoo9H3dRtDmjBZVMcKqvU2nray',
  DECIMALS: 9,
  SYMBOL: 'GBUX',
  USDT_MINT: 'Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB',
} as const;

export { GBUX, FLEET } from './fleet';
